/*
 *  操作码：   
    ERROR("-1","操作异常"),
    HEART("0","心跳"),              
    CONNECT_SUCCESS("1","连接成功"),      1
    EXIT_ROOM("99","退出房间"),           2
    JOIN_ROOM("100","进入房间"),           
    FACE("101","人脸验证"),
    FACE_ERR("102","人脸验证失败"),
    FACE_SUCCESS("103","人脸验证成功"),
    FACE_SKIP("104","跳过人脸"),
    EXIT_BACK("105","推到后台"),
    TO_FRONT("106","进入前台"),
    DISCONNECT("107","断开连接"),
    SCREEN_CAPTURE("108","屏幕截图"),
    SCREEN_VIDEO("109","录屏"),
    OUT_DEVICE("110","有外接设备"),
    DOWN_ZIP("204","下载资源"),
    DOWN_CANCEL("205","取消下载"),
    DOWN_SUCCESS("206","下载成功"),
    DOWN_ERROR("207","下载失败"),
    DEC_ERROR("208","解压缩失败"),
    DEC_SUCCESS("209","解压缩成功"),
    ANSWER_QUESTION("210","答题"),
    SWITCH_QUESTION("211","切换题目"),
    UPLOAD_OSS("212","上传oss"),
    UPLOAD_OSS_SUCCESS("213","上传oss成功"),
    UPLOAD_OSS_ERROR("214","上传oss失败"),
    DELETE_FILE("215","删除文件"),
    SUBMIT("216","交卷"),
    SUBMIT_SUCCESS("217","交卷成功"),
    SUBMIT_ERROR("218","交卷交卷失败"), 
    SUBMIT_ERROR("219","确认收到回复"), 

 *  发送json数据：
    stepId 步骤id //不传
    uuid 唯一标识
    roomNum 房间号[ 也可以为试卷id ]
    fromId  发送人id  uid
    fromName,//发送人名称
    userSignId 报名id 
    opCode 动作类型 参考opEnum 操作码
    pageName 页面名称 
    paperQuestionId 所在试卷题目id
    questionId 题id
    questionIndex当前第几题[从1开始]
    content 操作内容 //非必穿
    jsonVal 用户答题信息json    
    memory 内存
    cpu
    battery 电量
    downLink 下行网速
    upLink 上行网速
    opTime 客户发送时间 (北京时间)
    deviceName 设备名称 
    deviceSys设备系统 ios=ios android=安卓 web=网页
    deviceSysVer 设备系统版本
    appVer app版本 //web的版本
    audioUrl:语音地址
    audioEnUrl:语音地址(英文)
    youXunExamNum:优巡Exam账号
    ticketNum:准考证号
*/

import utils from './util'
import { getDateNow } from './youxunAPI';

class socketClient {
    wsUrl = '';
    wsAuto = {};
    websocket = null;

    sendObj = {
        uuid:'',
        roomNum:'',
        fromId:'',
        userSignId:'',
        opCode:'',
        pageName:'',
        paperQuestionId:'',
        questionId:'',
        questionIndex:'',
        content:'',
        jsonVal:'',
        opTime:'',
        deviceName:'',
        deviceSys:'web',
        deviceSysVer:'',
        appVer:'',
        ticketNum:'',
        youXunExamNum:'',
    }

    constructor(wsUrl, wsAuto) {
      //试卷id?fromId=用户id&userSignId=报名id
      this.wsUrl = `${process.env.SOCKET_API}/${wsUrl}`;
      this.wsAuto = wsAuto;
    }
    // 初始化socket
    initWebSocket() {
        return new Promise((resolve, reject) => {
            this.websocket = new WebSocket(this.wsUrl)
            this.wsOpen().then((res) => {
                this.wsSend(this.wsAuto);
                return resolve()
            });
        
            this.websocket.onerror = (evt) => {
                console.log("websocket 连接错误 ");
            };
        
            this.websocket.onclose = (evt) => {
                console.log("客户端断开连接！");
            };  
        })
    }
    // 打开连接
    wsOpen() {
      if (this.websocket) {
        return new Promise((resolve, reject) => {
          try {
            this.websocket.onopen = (evt) => {
              resolve(evt);
            };
          } catch (err) {
            reject(err);
          }
        });
      }
    }
    // 关闭连接
    wsClose() {
      if (this.websocket) {
        this.websocket.close();
        return new Promise((resolve, reject) => {
          try {
            this.websocket.onclose = (evt) => {
              console.log("客户端断开连接；");
              resolve(evt);
            };
          } catch (err) {
            reject(err);
          }
        });
      }
    }
    // 监听消息
    wsMessage(callback) {
      // 需要监听的消息路径
      if (this.websocket) {
        try {
          this.websocket.onmessage = (evt) => {
            // 判断是否有 data 数据
            if (evt.data) {
              let data = evt.data;
              if (this.isJsonString(data)) {
                callback(JSON.parse(data));
              }
            }
          };
        } catch (err) {
          callback(err);
        }
      }
    }
    // 发送消息
    wsSend(options) {
      if (this.websocket) {
        try {
          let opt = Object.assign(this.sendObj, options)
          opt.uuid = utils.uuid2(32)

          let poorTime = window.localStorage.getItem('poorVal')
          opt.opTime = Number(new Date().getTime()) + (poorTime? Number(poorTime):0)
          this.websocket.send(JSON.stringify(opt));
        } catch (e) {
          console.log('错误', e)
        }
      }
    }
    // 连接因错误而关闭时触发
    wsOnerror() {
      if (this.websocket) {
        return new Promise((resolve, reject) => {
          try {
            this.websocket.onerror = (evt) => {
              resolve(evt);
            };
          } catch (err) {
            reject(err);
          }
        });
      }
    }
    // 判断是否是json字符串
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {
        console.log("isJsonString:错误捕获");
      }
      return false;
    }
}
  
export { socketClient };


// WEBPACK FOOTER //
// ./src/lib/socket.js